// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rate_wrapper__3572W","amount":"rate_amount__1Ur3d","disabled":"rate_disabled__1cO3R"};